/* TP Smart v1 (11.10.2026) - comportament aditional peste tp-app-ui.js.
   Defensiv: orice eroare e inghitita ca sa nu opreasca restul paginii. Oprire rapida: adauga ?tps=0 in link.
   Revenire completa: scoate liniile tp-smart.* din layout/theme.liquid. */
(() => {
  'use strict';
  if (window.__tpSmart) return;
  if (/[?&]tps=0(&|$)/.test(location.search)) return;
  window.__tpSmart = true;

  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 767px)');
  const safe = (fn, fallback) => { try { return fn(); } catch (e) { return fallback; } };
  const $ = (sel, scope = document) => scope.querySelector(sel);
  const $$ = (sel, scope = document) => [...scope.querySelectorAll(sel)];
  const SIZE_PARAM = 'filter.v.option.shoe size';
  const LS_KEY = 'tp_size_v1';
  const PDP_SIZE_HINT = false;   // 24.10.2026: indiciul "Marimea ta" + bifarea automata pe pagina de produs, oprite la cererea lui Stefan (true = revin)

  root.classList.add('tps');
  if ($('[data-tp-product]')) root.classList.add('tps-pdp');

  /* ================= 0. memoria marimii (doar in browserul clientului, la actiunea lui) ================= */
  const mem = {
    read() { return safe(() => JSON.parse(localStorage.getItem(LS_KEY) || 'null'), null) || { v: {}, last: '' }; },
    write(m) { safe(() => localStorage.setItem(LS_KEY, JSON.stringify(m))); },
    get(ctx) {
      const m = this.read();
      if (ctx && ctx !== 'any') return (m.v && m.v[ctx]) || '';
      return m.last || '';
    },
    set(ctx, size) {
      const m = this.read();
      m.v = m.v || {};
      if (ctx && ctx !== 'any') m.v[ctx] = size;
      m.last = size; m.t = Date.now();
      this.write(m);
    },
    clear(ctx) {
      const m = this.read();
      if (ctx && ctx !== 'any' && m.v) delete m.v[ctx];
      if (m.last && (!ctx || ctx === 'any' || !Object.keys(m.v || {}).length)) m.last = '';
      this.write(m);
    }
  };
  // context = gen (w femei, m barbati, k copii, any = amestecat/necunoscut)
  const ctxFromText = text => {
    const t = String(text || '').toLowerCase();
    const w = /dam[aă]|femei/.test(t), m = /b[aă]rba[tț]/.test(t), k = /copii|copil\b|baie[tț]i|fete\b|junior/.test(t);
    const n = (w ? 1 : 0) + (m ? 1 : 0) + (k ? 1 : 0);
    if (n === 0) return '';
    if (n > 1) return 'any';
    return w ? 'w' : m ? 'm' : 'k';
  };
  const pathCtx = () => ctxFromText(safe(() => decodeURIComponent(location.pathname), location.pathname));
  const cardsCtx = scope => {
    const cards = $$('[data-tp-app-card]', scope || document);
    if (cards.length < 6) return '';
    const w = cards.filter(c => c.dataset.tpGender === 'women').length;
    const m = cards.filter(c => c.dataset.tpGender === 'men').length;
    if (w / cards.length >= 0.8) return 'w';
    if (m / cards.length >= 0.8) return 'm';
    return 'any';
  };
  const inStockOff = () => safe(() => sessionStorage.getItem('tp_in_stock_user_preference') === 'unchecked', false);
  const tpsOff = () => safe(() => sessionStorage.getItem('tps_size_off') === '1', false);
  const setTpsOff = v => safe(() => { if (v) sessionStorage.setItem('tps_size_off', '1'); else sessionStorage.removeItem('tps_size_off'); });

  /* ================= 1. bara de sus: se strange dupa primul scroll, se ascunde in jos, reapare in sus ================= */
  safe(() => {
    let lastY = window.scrollY, ticking = false, hidden = false;
    const setHidden = value => { if (value === hidden) return; hidden = value; root.classList.toggle('tps-hdr-hidden', value); };
    const modalOpen = () => root.classList.contains('tp-catalog-is-open') || root.classList.contains('tp-cart-is-open');
    function tick() {
      ticking = false;
      const y = Math.max(0, window.scrollY);
      const dy = y - lastY;
      root.classList.toggle('tps-scrolled', y > 32);
      if (!modalOpen()) {
        const minY = mobile.matches ? 140 : 280;   /* ux-audit 16.10.2026: si pe desktop (antetul de ~240 px acoperea o treime din ecran) */
        if (y < minY) setHidden(false);
        else if (dy > 6) setHidden(true);
        else if (dy < -6) setHidden(false);
      } else setHidden(false);
      lastY = y;
    }
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }, { passive: true });
    mobile.addEventListener('change', () => setHidden(false));
    tick();
  });

  /* ================= 2. bara de avantaje pe telefon: text scurt + rotire automata ================= */
  safe(() => {
    let tries = 0, idx = 0, timer = 0;
    function init() {
      const strip = $('.tp-usp');
      if (!strip) { if (++tries < 40) setTimeout(init, 150); return; }
      const first = $('.tp-usp__item span', strip);
      if (first && !first.dataset.full) first.dataset.full = first.textContent;
      const apply = () => { if (first) first.textContent = mobile.matches ? 'Livrare GRATUITĂ la orice comandă' : first.dataset.full; };
      apply(); mobile.addEventListener('change', apply);
      clearInterval(timer);
      timer = setInterval(() => {
        if (!mobile.matches || root.classList.contains('tps-scrolled') || document.hidden) return;
        const items = strip.children;
        if (items.length < 2) return;
        idx = (idx + 1) % items.length;
        strip.scrollTo({ left: items[idx].offsetLeft - strip.offsetLeft, behavior: 'smooth' });
      }, 3800);
    }
    init();
  });

  /* ================= 3. estimare livrare: detaliile se deschid la atingerea liniei principale ================= */
  document.addEventListener('click', event => {
    safe(() => {
      const primary = event.target.closest('.tp-delivery-estimate .tp-de__primary');
      if (primary && mobile.matches) primary.closest('.tp-delivery-estimate').classList.toggle('tps-de-open');
    });
  });

  /* ================= 4. colectii: bara "Marimea ta" (chipurile comanda filtrul real din formular) ================= */
  function sizeForm(scope) {
    const rootEl = scope.closest ? scope.closest('[data-tp-collection]') : null;
    return rootEl ? $('form[data-tp-filters]', rootEl) : null;
  }
  function applySize(bar, size) {
    const form = sizeForm(bar);
    if (!form) return false;
    const param = bar.dataset.tpsParam || SIZE_PARAM;
    const boxes = $$('input[type="checkbox"]', form);
    boxes.filter(i => i.name === param).forEach(i => { i.checked = size !== null && i.value === size; });
    if (size !== null && !inStockOff()) {
      const av = boxes.find(i => i.name === 'filter.v.availability' && i.value === '1');
      if (av) av.checked = true;
    }
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    return true;
  }
  document.addEventListener('click', event => {
    safe(() => {
      const chip = event.target.closest('.tps-sizebar [data-tps-size]');
      const clear = event.target.closest('[data-tps-size-clear]');
      if (!chip && !clear) return;
      const bar = (chip || clear).closest('[data-tps-sizebar]');
      const ctx = pathCtx() || cardsCtx() || 'any';
      if (clear) {
        setTpsOff(true);
        applySize(bar, null);
        return;
      }
      const value = chip.dataset.tpsSize;
      if (chip.classList.contains('is-on')) { setTpsOff(true); applySize(bar, null); return; }
      setTpsOff(false);
      mem.set(ctx, value);
      applySize(bar, value);
    });
  });
  // la intrarea pe o colectie de gen (dama/barbati/copii) aplicam singuri marimea memorata, o singura data
  function autoApplyCollection() {
    const col = $('[data-tp-collection]');
    if (!col) return false;
    const bar = $('[data-tps-sizebar]', col);
    const ctx = pathCtx();
    if (!bar || !ctx || ctx === 'any') return false;
    if (/filter\.v\.option/.test(decodeURIComponent(location.search))) return false;
    if ($('.tps-chip.is-on', bar) || tpsOff()) return false;
    const size = mem.get(ctx);
    if (!size) return false;
    const chip = $$('[data-tps-size]', bar).find(c => c.dataset.tpsSize === size);
    if (!chip) return false;
    window.__tpAutoUntil = Date.now() + 4000;
    return applySize(bar, size);
  }
  let rootAtApply = null;   // radacina colectiei in momentul aplicarii automate (masca ramane pana apare cea noua)
  function afterRender() {
    if (!rootAtApply || $('[data-tp-collection]') !== rootAtApply) { rootAtApply = null; root.classList.remove('tps-pending'); }
    // chipul activ la vedere
    $$('.tps-sizebar__chips').forEach(row => {
      const on = $('.tps-chip.is-on', row);
      if (on) row.scrollLeft = Math.max(0, on.offsetLeft - row.clientWidth / 2 + on.offsetWidth / 2);
    });
    // marimea ta iese in evidenta pe carduri
    const ctx = pathCtx() || cardsCtx() || 'any';
    const active = $('.tps-sizebar .tps-chip.is-on');
    const mine = active ? active.dataset.tpsSize : mem.get(ctx);
    if (mine) {
      $$('.tp-size--available:not([data-tps-m="1"])').forEach(a => {
        a.dataset.tpsM = '1';
        const label = $('.tp-size__label', a);
        if (label && label.textContent.trim().replace(',', '.') === mine) a.classList.add('tps-mine');
      });
    }
  }
  safe(() => {
    let booted = false;
    const boot = () => {
      if (booted) return;
      booted = true;
      const before = $('[data-tp-collection]');
      if (autoApplyCollection()) rootAtApply = before; else afterRender();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    let timer = 0;
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(() => safe(afterRender), 80); })
      .observe(document.body, { childList: true, subtree: true });
    setTimeout(() => { rootAtApply = null; root.classList.remove('tps-pending'); }, 2600);   // plasa de siguranta: masca nu ramane niciodata
  });

  /* ================= 5. pagina de produs: marimea ta (indiciu + memorare) ================= */
  function initPdp() {
    if (!PDP_SIZE_HINT) return;
    const prod = $('[data-tp-product]');
    if (!prod || prod.dataset.tpsReady) return;
    prod.dataset.tpsReady = '1';
    const sizeIndex = Number(prod.dataset.tpSizeIndex);
    if (!(sizeIndex >= 0)) return;
    const group = $(`[data-tp-option-index="${sizeIndex}"]`, prod);
    if (!group) return;
    const specs = $('.tp-product-specs', prod);
    const ctx = ctxFromText((($('h1', prod) || {}).textContent || '') + ' ' + (specs ? specs.textContent : '')) || 'any';
    // linkul categoriei (ex. Pantofi sport dama) are prioritate fata de brand: ofera mai multe alternative in marimea ta
    const catRow = $$('.tp-product-specs > div', prod).find(row => /categorie/i.test((($('dt', row) || {}).textContent) || ''));
    const typeLink = (catRow && $('a[href*="/collections/"]', catRow)) || $('.tp-product-specs a[href*="/collections/"]', prod) || $('.tp-breadcrumbs a[href*="/collections/"]');
    const hint = document.createElement('div');
    hint.className = 'tps-sizehint';
    hint.setAttribute('role', 'status');
    hint.hidden = true;
    group.insertAdjacentElement('afterend', hint);

    const radios = () => $$('input[type="radio"]', group);
    const norm = s => String(s == null ? '' : s).trim().replace(',', '.');
    function altUrl(size) {
      const base = typeLink ? typeLink.getAttribute('href') : '/collections/toate-produsele';
      const u = new URL(base, location.origin);
      u.search = '';
      u.searchParams.set('filter.v.availability', '1');
      u.searchParams.set(SIZE_PARAM, size);
      return u.pathname + u.search;
    }
    function render() {
      const mine = norm(mem.get(ctx));
      radios().forEach(r => r.closest('label') && r.closest('label').classList.remove('tps-option-mine'));
      hint.hidden = true; hint.className = 'tps-sizehint';
      if (!mine) return;
      const match = radios().find(r => norm(r.value) === mine);
      if (match) match.closest('label').classList.add('tps-option-mine');
      if (match && match.checked) return;
      const free = radios().filter(r => !r.disabled).map(r => r.value);
      if (match && !match.disabled) {
        hint.textContent = `Mărimea ta (${mine}) este în stoc la acest model.`;
        hint.hidden = false;
        return;
      }
      hint.classList.add('tps-sizehint--warn');
      const where = altUrl(mine);
      const label = match ? `Mărimea ta (${mine}) nu mai este în stoc la acest model.` : `Acest model nu se face în mărimea ta (${mine}).`;
      const more = free.length ? ` Disponibile: ${free.slice(0, 8).join(', ')}.` : '';
      hint.textContent = label + more + ' ';
      const a = document.createElement('a');
      a.href = where; a.textContent = `Vezi modele în mărimea ${mine}`;
      hint.append(a);
      hint.hidden = false;
    }
    group.addEventListener('change', event => {
      safe(() => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.checked) return;
        if (!mem.get(ctx)) mem.set(ctx, input.value);   // prima selectie memoreaza; schimbarea ulterioara se face din chipuri
        render();
      });
    });
    // atingere pe o marime epuizata = "asta e marimea mea": o memoram si aratam alternativele (in loc de un tap fara raspuns)
    group.addEventListener('click', event => {
      safe(() => {
        const label = event.target.closest('label.tp-option-choice');
        const input = label && $('input[type="radio"]', label);
        if (!input || !input.disabled) return;
        mem.set(ctx, input.value);
        render();
        if (!hint.hidden) hint.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    });
    // tps-autopick-20261024: marimea memorata, in stoc, cand nimic nu e ales -> o bifam de la inceput
    // (altfel chipul 'Marimea ta' arata ca ales, dar butonul zice 'Alege marimea' pana la inca un click)
    function autoPick(tries) {
      safe(() => {
        if (prod.dataset.tpReady !== 'true') { if ((tries || 0) < 40) setTimeout(() => autoPick((tries || 0) + 1), 50); return; }   // tp-app-ui inca nu a pornit
        const mine = norm(mem.get(ctx));
        if (!mine || radios().some(r => r.checked)) return;
        const match = radios().find(r => norm(r.value) === mine);
        if (!match || match.disabled) return;
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    autoPick();
    document.addEventListener('tp:cart-updated', () => safe(() => {
      const checked = radios().find(r => r.checked);
      if (checked) { mem.set(ctx, checked.value); render(); }   // achizitia confirma marimea
    }));
    render();
  }
  safe(initPdp);
  document.addEventListener('shopify:section:load', () => safe(initPdp));

  /* ================= 6. prima pagina: "Gaseste perechea ta" ================= */
  function initFinder() {
    const f = $('[data-tps-finder]');
    if (!f || f.dataset.ready) return;
    f.dataset.ready = '1';
    const RANGES = {
      w: ['35', '36', '37', '38', '39', '40', '41', '42'],
      m: ['40', '41', '42', '43', '44', '45', '46', '47'],
      k: ['24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38']
    };
    const param = f.dataset.param || SIZE_PARAM;
    const P_TIP = 'filter.p.m.custom.tip_pantof', P_COL = 'filter.p.m.custom.culoare_baza', P_BRAND = 'filter.p.vendor';
    const urls = { w: f.dataset.urlW, m: f.dataset.urlM, k: f.dataset.urlK };
    const names = { w: 'femei', m: 'bărbați', k: 'copii' };
    const segBtns = $$('[data-tps-seg]', f);
    const chipsBox = $('[data-tps-chips]', f);
    const brandSel = $('[data-tps-brand]', f);
    const cta = $('[data-tps-cta]', f);
    let seg = 'w', size = '', tip = '', col = '', token = 0, timer = 0;
    const m0 = mem.read();
    const prefer = ['w', 'm', 'k'].find(g => m0.v && m0.v[g]);
    if (prefer) seg = prefer;

    function params(u) {
      u.searchParams.set('filter.v.availability', '1');
      if (size) u.searchParams.set(param, size);
      if (tip) u.searchParams.set(P_TIP, tip);
      if (col) u.searchParams.set(P_COL, col);
      if (brandSel.value) brandSel.value.split('|').forEach(v => u.searchParams.append(P_BRAND, v));
    }
    function base() { const u = new URL(urls[seg] || '/collections/toate-produsele', location.origin); u.search = ''; return u; }
    function link() {
      const u = base();
      if (f.dataset.view) u.searchParams.set('view', f.dataset.view);   // dama/barbati/copii sunt pagini-hub: view=tp-app arata lista de produse
      params(u);
      return u.pathname + u.search;
    }
    async function count() {
      const my = ++token;
      const u = base();
      u.searchParams.set('view', 'tps-count');
      params(u);
      try {
        const res = await fetch(u.href, { credentials: 'same-origin' });
        const n = parseInt((await res.text()).trim(), 10);
        if (my !== token || !(n >= 0)) return;
        cta.textContent = n > 0 ? `Vezi ${n} ${n === 1 ? 'model' : 'modele'}${size ? ' în mărimea ' + size : ''}` : `Nu avem acum această combinație la ${names[seg]}`;
        cta.setAttribute('aria-disabled', n > 0 ? 'false' : 'true');
        cta.href = link();
      } catch (e) { cta.href = link(); }
    }
    function render() {
      segBtns.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tpsSeg === seg)));
      const saved = mem.get(seg);
      if (!size && saved && RANGES[seg].includes(saved)) size = saved;
      if (size && !RANGES[seg].includes(size)) size = '';
      chipsBox.replaceChildren(...RANGES[seg].map(s => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'tps-chip tps-chip--plain' + (s === size ? ' is-on' : '');
        b.dataset.tpsFsize = s; b.setAttribute('aria-pressed', String(s === size));
        const span = document.createElement('span'); span.textContent = s; b.append(span);
        return b;
      }));
      $$('[data-tps-tip]', f).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tpsTip === tip)));
      $$('[data-tps-col]', f).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.tpsCol === col)));
      cta.href = link();
      cta.setAttribute('aria-disabled', 'false');
      cta.textContent = 'Vezi modelele';
      clearTimeout(timer); timer = setTimeout(count, 120);
    }
    f.addEventListener('click', event => {
      safe(() => {
        const sb = event.target.closest('[data-tps-seg]');
        if (sb) { seg = sb.dataset.tpsSeg; size = ''; render(); return; }
        const cb = event.target.closest('[data-tps-fsize]');
        if (cb) { size = size === cb.dataset.tpsFsize ? '' : cb.dataset.tpsFsize; if (size) { mem.set(seg, size); setTpsOff(false); } render(); return; }
        const tb = event.target.closest('[data-tps-tip]');
        if (tb) { tip = tip === tb.dataset.tpsTip ? '' : tb.dataset.tpsTip; render(); return; }
        const kb = event.target.closest('[data-tps-col]');
        if (kb) { col = col === kb.dataset.tpsCol ? '' : kb.dataset.tpsCol; render(); return; }
        if (event.target.closest('[data-tps-cta]') && cta.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
    });
    brandSel.addEventListener('change', () => safe(render));
    render();
  }
  safe(initFinder);

  /* ================= 7. navigare instant: prerender la hover/atingere (Chrome) + prefetch bara de jos ================= */
  safe(() => {
    if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
    if (/[?&]tps=0(&|$)/.test(location.search)) return;
    const P = location.pathname;
    if (/^\/(cart|checkout|account|checkouts|orders|search)/.test(P)) return;
    const okLink = { and: [
      { or: [{ href_matches: '/products/*' }, { href_matches: '/collections/*' }, { href_matches: '/pages/*' }, { href_matches: '/blogs/*' }, { href_matches: '/' }] },
      { not: { selector_matches: '[rel~=nofollow], [data-no-prerender], [target=_blank]' } },
      { not: { href_matches: '/*\?*(add|checkout|logout|return_to|view=tps-count)*' } }
    ] };
    const s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify({
      prerender: [{ where: okLink, eagerness: 'moderate' }],
      prefetch: [
        { where: { and: [{ selector_matches: '.tp-mobile-nav a, header nav a, .tp-usp a' }, okLink] }, eagerness: 'eager' },
        { where: okLink, eagerness: 'moderate' }
      ]
    });
    document.head.appendChild(s);
  });
})();
